import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import { useSettings } from "../../context/SettingsContext";
export const useSignin = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-authenticate'], queryFn: async ({ signal }) => {
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'authenticate', 'user');
            let data = {
                username: formContext.getValues('username'),
                password: formContext.getValues('password')
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
